import ettxBackgroundImage from '@/assets/Screen_BG.png';
import ettxBackgroundImageTablet from '@/assets/Smaller_Screen_IMG.png';
import ettxLogoDark from '@/assets/svg/ettx-logo-dark.svg';
import theme from '@/common/theme';
import OutletWrapper from '@/components/animations/animated-routes/animated-outlet';
import styled from 'styled-components';

/**
 * The LoginLayout component.
 * @returns {JSX.Element} The rendered LoginLayout component.
 */
const LoginLayout = () => (
  <ImageBackground>
    <Logo src={ettxLogoDark} alt="logo" />
    <FormContainer>
      <OutletWrapper slide={25} slideUp={0} keyType="segment" />
    </FormContainer>
  </ImageBackground>
);

const ImageBackground = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  background-size: cover;
  background-image: url(${ettxBackgroundImage});
  @media (max-width: 1025px) {
    background-image: url(${ettxBackgroundImageTablet});
  }
`;

const Logo = styled.img`
  display: flex;
  width: 177px;
  height: 88px;
  margin-top: 74px;
  margin-right: 60px;
  margin-left: auto;

  @media (orientation: portrait) {
    margin-right: 20px;
  }
`;

const FormContainer = styled.div`
  padding: 20px;
  border-radius: 8px;
  margin-left: auto;
  margin-right: 10%;
  margin-top: 5%;
  max-width: 500px;
  background-color: ${() => theme.COLOR_WHITE};
  border-radius: 8px;

  @media (max-width: 1025px) {
    margin: auto;
    margin-top: 5%;
    background-color: ${() => theme.COLOR_WHITE};
    box-shadow: 0px 2px 16px 0px #07002f1a;
  }
`;

export default LoginLayout;
